export const environment = {
  apiUrl: 'https://faceb2b.gob.es/api',
  apiHost: 'faceb2b.gob.es',
  direUrl: 'https://dire.gob.es/gestion/inicio',
  production: true,
  prefix: 'prod',
  googleAnalyticsUA: 'UA-57925873-6',
  devLogin: false,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts